//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getCurrentSelectedCuids = createSelector(
  (state: ICuralateStore) => state.instagram.postDetails.currentPostDetails,
  (currentPostDetails) => currentPostDetails.selectedCuids ?? [],
);

export const getCurrentSelectedReelsCuid = createSelector(
  (state: ICuralateStore) =>
    state.instagram.postDetails.reels.currentReelsPostDetails,
  (currentReelsPostDetails) => currentReelsPostDetails.cuid,
);
